import React from 'react';
import { Palette, Globe, Layers } from 'lucide-react';
import { tradeFocus } from '@/data/mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const iconMap = {
  Palette: Palette,
  Globe: Globe,
  Layers: Layers
};

const TradeFocusSection = () => {
  return (
    <section id="trade-focus" className="py-20 md:py-32 bg-accent/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
            Our Trade Focus
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Connecting global markets with India's manufacturing excellence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {tradeFocus.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-border/50 bg-background/50 backdrop-blur-sm"
              >
                <CardHeader>
                  <div className="mb-4 h-48 overflow-hidden rounded-lg bg-accent/30">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-foreground/5 dark:bg-amber-600/20 rounded-lg group-hover:bg-foreground/10 dark:group-hover:bg-amber-600/30 transition-colors">
                      <IconComponent className="h-6 w-6 dark:text-amber-500" />
                    </div>
                  </div>
                  <CardTitle className="text-xl">{item.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TradeFocusSection;
